import React from 'react';
import PropTypes from 'prop-types';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import classnames from 'classnames';
import { connect } from 'react-redux';
import AddButtonLong from '../AddButtonLong';
import { triggerCreate } from '../../redux/actions';

const style = {
  fontFamily: 'Google Sans, sans-serif',
  fontWeight: 500,
  color: '#292929',
  fontSize: '18px',
  WebkitFontSmoothing: 'antialiased',
  display: 'flex',
  alignItems: 'flex-start',
  width: '100%',
  justifyContent: 'space-between'
};

const ViewTitle = ({
  className, title, onAddButtonClick, addButton, ...rest
}) => (
  <CardContent
    style={{
      paddingLeft: '20px',
      paddingTop: '17px',
      width: '100%',
      height: '50px'
    }}
    className={classnames('title', className)}
    {...rest}
  >
    <Typography style={style} variant="title">{title} {addButton && <AddButtonLong click={() => { onAddButtonClick(true); }} />}</Typography>
  </CardContent>
);

ViewTitle.propTypes = {
  className: PropTypes.string,
  onAddButtonClick: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  addButton: PropTypes.bool
};

ViewTitle.defaultProps = {
  addButton: false
};

export default connect(null, {
  onAddButtonClick: triggerCreate
})(ViewTitle);



// WEBPACK FOOTER //
// ./src/components/ejected/ViewTitle.js